module.exports = __webpack_public_path__ + "static/img/1-03.f152ab1.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-03.png
// module id = 204
// module chunks = 0